module.exports = __webpack_public_path__ + "static/media/a1.e0c22262.png";